module.exports = __webpack_public_path__ + "img/img_isms_w116.480a4327.png";